import { createTrackingPageProvider } from '@edreamsodigeo/frontend-core';
export const PAY_PAGE = '/payment/error/';
export const BrokenFlowModalTrackingProvider = createTrackingPageProvider({
  pageMapper: () => PAY_PAGE
});
export default BrokenFlowModalTrackingProvider;